import React from "react";
import InstagramIcon from "../assets/instagram-icon.png";
import TikTokIcon from "../assets/tik-tok-icon.png";
import "../styles/Footer.css";

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <div className="footer">
            <div className="socialMedia">
                <img src={InstagramIcon} alt="Instagram" className="social-icon" />
                <img src={TikTokIcon} alt="TikTok" className="social-icon" />
            </div>
            <p> &copy; {currentYear} verdant.co &bull; All rights reserved.</p>
        </div>
    )
}

export default Footer;